import type { Resource } from '../../';
export const product_sizeChart_category_women: Resource = {"default":"Women"};
